export default "__VITE_ASSET__DCL6NGVP__"